import React from 'react';
import styles from './DataExtractionNavigationItems.module.scss';
import { Button } from 'components/core';
import {
  tokenizeRoute,
  CHOOSE_YOUR_TEMPLATE_ROUTE,
  getTemplateRoute,
} from 'query/routes';
import { getReviewId } from 'query/review';

type Props = {
  hasExtractionTemplate: boolean;
  hasQualityTemplate: boolean;
  reviewerCanEditTemplate: boolean;
  isDe2?: boolean;
};

const DataExtractionNavigationItems = ({
  hasExtractionTemplate,
  hasQualityTemplate,
  reviewerCanEditTemplate,
  isDe2 = false,
}: Props) => {
  const reviewId = getReviewId();

  const showChooseYourTemplatePage =
    !hasExtractionTemplate && !hasQualityTemplate;

  const getDERoute = () => {
    if (showChooseYourTemplatePage) {
      return tokenizeRoute(CHOOSE_YOUR_TEMPLATE_ROUTE, {
        review_id: reviewId,
        backTo: 'study_list',
        type: 'de',
      });
    }

    return getTemplateRoute({ isDe2, reviewId, type: 'de' });
  };

  const getQARoute = () => {
    if (showChooseYourTemplatePage) {
      return tokenizeRoute(CHOOSE_YOUR_TEMPLATE_ROUTE, {
        review_id: reviewId,
        backTo: 'study_list',
        type: 'qa',
      });
    }

    return getTemplateRoute({ isDe2, reviewId, type: 'qa' });
  };

  if (reviewerCanEditTemplate) {
    return (
      <div className={styles.DataExtractionNavigationItems}>
        <Button
          type={hasExtractionTemplate ? 'neutral' : 'brand'}
          variant={hasExtractionTemplate ? 'outline' : 'solid'}
          to={getDERoute()}
        >
          {hasExtractionTemplate
            ? 'Data extraction template'
            : 'Create data extraction template'}
        </Button>
        <Button
          type={hasQualityTemplate ? 'neutral' : 'brand'}
          variant={hasQualityTemplate ? 'outline' : 'solid'}
          to={getQARoute()}
        >
          {hasQualityTemplate
            ? 'Quality assessment template'
            : 'Create quality assessment template'}
        </Button>
      </div>
    );
  } else {
    return null;
  }
};

export default DataExtractionNavigationItems;
